import { render, staticRenderFns } from "./LogPowerBI.vue?vue&type=template&id=a169d920&scoped=true"
import script from "./LogPowerBI.vue?vue&type=script&lang=js"
export * from "./LogPowerBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a169d920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a169d920')) {
      api.createRecord('a169d920', component.options)
    } else {
      api.reload('a169d920', component.options)
    }
    module.hot.accept("./LogPowerBI.vue?vue&type=template&id=a169d920&scoped=true", function () {
      api.rerender('a169d920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/powerbi_log_report/LogPowerBI.vue"
export default component.exports